import {
  Badge,
  BadgeVariant,
} from '../../../components/atoms/badge/badge';
import { STATUS_AVISO_LABEL, StatusAviso } from '../../../types/aviso';

const variantByStatus: Record<StatusAviso, BadgeVariant> = {
  [StatusAviso.ACTIVE]: 'success',
  [StatusAviso.SCHEDULED]: 'info',
  [StatusAviso.EXPIRED]: 'neutral',
  [StatusAviso.INACTIVE]: 'neutral',
};

interface Props {
  status: StatusAviso | null;
}

export const AvisoStatusBadge = ({ status }: Props) => {
  if (status == null) return <Badge variant="neutral">—</Badge>;
  return (
    <Badge variant={variantByStatus[status] ?? 'neutral'}>
      {STATUS_AVISO_LABEL[status] ?? status}
    </Badge>
  );
};
